/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './exportDetails.tpl.html';

/**
 * Module for the exportDetails.
 */
angular
  .module('batch.export.details', [])
  /**
   * Controller for the exportDetails template.
   */
  .controller('ExportDetailsCtrl', function ($scope, TYPES) {
    var objectTypes = [];
    $scope.TYPES = TYPES;

    // object used to track the difference properties that drive the table.
    $scope.headerValues = {
      type: 'type',
      size: 'size',
      records: 'records'
    };
    // property used to order the data in the table.  It must match one of the keys from the headerValues obj.
    $scope.predicate = $scope.headerValues.type;
    // direction of the data.
    $scope.reverse = false;

    _.each($scope.batchUtils.currentBatch.typeCounts, function (counts, type) {
      objectTypes.push({
        type: type,
        size: counts.size || 0,
        records: counts.exported
      });
    });

    $scope.objectTypes = objectTypes;
  });
